import React from 'react'
import BaseLocationsDashboard from '../pages/baseLocations/BaseLocationsDashboard'
import BaseLocationPage from '../pages/baseLocations/BaseLocationPage/BaseLocation'
import CoshhPublicView from '../pages/baseLocations/CoshhPublicView'

// /coshh/:token is also registered in PublicRouter so the QR code works
// logged-out; this copy catches logged-in users scanning the same code.
export default [
  { path: '/base-locations', element: <BaseLocationsDashboard />, title: 'Base Locations' },
  { path: '/base-locations/:id', element: <BaseLocationPage /> },
  { path: '/coshh/:token', element: <CoshhPublicView />, title: 'COSHH' },
]
